import {
  formatDateForKotlin,
  formatDateStringSvkForKotlin,
  makeDateFromKotlin,
  makeDateFromNativeInput,
  makeDateForNativeInput,
  getMonthByWord,
  makeDateStringFromKotlin,
  treatAsUTC,
  daysBetween,
  addYears
} from "./date";

export {
  formatDateForKotlin,
  formatDateStringSvkForKotlin,
  makeDateFromKotlin,
  makeDateFromNativeInput,
  makeDateForNativeInput,
  getMonthByWord,
  makeDateStringFromKotlin,
  treatAsUTC,
  daysBetween,
  addYears
}

const kotlin = (Kotlin) => {
  let helpers = Object.entries(Kotlin.helpers);

  /*
  * Odstrani kotlinovske pripony funkcii v helperoch.
  * Napr. ak nazov funkcie je yearDiffExact_wmumac$ zmeni ho na yearDiffExact
  * */
  const newHelpers = helpers.reduce((acc, helperEntry) => {
    const [helperKey, Helper] = helperEntry;
    const helperFunctions = Object.entries(new Helper().__proto__)
      .reduce((functionsAcc, functionEntry) => {
        const [key, fn] = functionEntry;
        functionsAcc[key.split('_')[0]] = (...args) => new Helper().__proto__[key](...args)
        return functionsAcc;
      }, {});
    acc[helperKey] = helperFunctions;
    return acc;
  }, {});

  /*
  * Odstrani kotlinovske pripony funkcii vo validatoroch.
  * Napr. ak nazov funkcie je emailValidator_61zpoe$ zmeni ho na emailValidator
  * */
  let newValidators = {};
  if (!!Kotlin.validators) {
    newValidators = Object.entries(Kotlin.validators).reduce((acc, validatorEntry) => {
      const [validatorKey, fn] = validatorEntry;
      acc[validatorKey.split('_')[0]] = (...args) => Kotlin.validators[validatorKey](...args);
      return acc;
    }, {});
  }

  /*
  * Najdi funckiu validate, ktora zvaliduje cely model a vrati pole errorov.
  * */
  // eslint-disable-next-line
  const validateModelFnName = Object.keys(new Kotlin.Validator().__proto__)
    .find((fnName) => fnName.indexOf('validate_') !== -1);

  return {
    ...Kotlin,
    helpers: newHelpers,
    validators: newValidators,
    validateModelFnName,
  };
};

export default {
  install(Vue, Kotlin) {
    Vue.prototype.$kotlin = kotlin(Kotlin);
  },
};
